import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useProfileService } from '../../../../apis/profile/useProfileService';
import { TProfileDocumentsApiResponse } from '../../../../apis/profile/profile.interfaces';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getProfilePersonalDocumentsKey = 'get-profile-personal-documents';

export const useProfilePersonalDocumentsHook = (
  userId: string,
  _params: TPaginationParams
): UseQueryResult<TProfileDocumentsApiResponse, TQueryError> => {
  const { getProfileDocuments } = useProfileService();

  return useQuery<TProfileDocumentsApiResponse, TQueryError>({
    queryKey: [getProfilePersonalDocumentsKey, _params],
    queryFn: () => getProfileDocuments(userId, _params),
  });
};
